/**
 * Module dependencies.
 */

import { RouterLink } from 'src/components/core/links/router-link';
import { transparentize } from 'src/styles/utils/colors';
import styled from 'styled-components';

/**
 * `CardLink` styled component.
 */

export const CardLink = styled(RouterLink)`
  background-color: ${transparentize('cyan800', 0.16)};
  border-radius: var(--border-radius-sm);
  display: block;
  padding: var(--space-sm);
  transition: background-color var(--transition-default);

  :active,
  :focus,
  :hover {
    background-color: ${transparentize('cyan800', 0.3)};
  }
`;
